import React from 'react'
import Education from './Education'
import Skill from './Skill'
import ResumePdf from './ResumePdf';

const About = () => {
  return (
    <div className='m-8 mt-0'>
 {/* <PDFViewer>
 <Text>Download now</Text>
    <ResumePdf />
  </PDFViewer> */}

    <div className='text-center'>
<div className="md:text-5xl  mb-8 text-center font-extrabold ...">
            <span className="bg-clip-text text-transparent  bg-gradient-to-r from-yellow-500 to-violet-500 mt-1   ">
             Researcher, Educator, Teacher, Scholar
            </span>
          </div>

    <h1 className='mt-4 text-bold my-2  text-xl'>
     
 
    </h1>
    <div className='w-23 h-23'>
    <img src="eduResearch.jpg" className='lg:rounded-full rounded-2xl mx-auto w-36 h-36 ' alt="img"  ></img>
    </div>
    <p className='my-3 text-justify md:text-center'>I hold a Ph.D. degree in Economics and work as an Assistant Professor with IoBM. Mainly I teach Principles of Microeconomics and Macroeconomics, Managerial Economics, Micro and Macroeconomics, and Seminar in Economic Policy I am also supervising my MPhil thesis and looking to supervise more on Governance and Macroeconomic issues. My research articles are published in many HEC and Scopus-recognized journals. In fact, she has participated and presented papers at several international conferences.</p>
    </div>
     

    

<Education/>

     <Skill/>

 
    </div>
  )
}

export default About